/* Carole Box 100 % Shopify (14 oct. 2026, Claude).
   Les pièces choisies sont ajoutées une par une au panier normal (propriété cachée _box).
   Le rabais vient des rabais automatiques Shopify « N pièces et + » (3 = -15 %, 5 = -20 %, 7 = -25 %, 10 = -30 %).
   Plus de service externe ni de commande provisoire. Retour arrière : retirer la ligne <script> de templates/page.build-your-box.liquid
   (et réactiver les 4 rabais « Box vintage » si on revient au service de Gab). */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fr = (document.documentElement.lang || '').indexOf('fr') === 0;
  function t(en, f) { return fr ? f : en; }
  async function create(opts) {
    var items = (opts && opts.items) || [];
    if (opts && typeof opts.onStep === 'function') opts.onStep('add');
    var cart = await fetch(root + 'cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
    var inCart = {};
    cart.items.forEach(function (i) { inCart[String(i.variant_id)] = true; });
    var label = 'Box ' + items.length + (fr ? ' pièces' : ' pieces');
    var toAdd = items.filter(function (i) { return !inCart[String(i.id).split('/').pop()]; })
      .map(function (i) { return { id: Number(String(i.id).split('/').pop()), quantity: 1, properties: { _box: label } }; });
    if (toAdd.length) {
      var r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: toAdd }) });
      if (!r.ok) {
        var d = {}; try { d = await r.json(); } catch (e) {}
        var err = new Error(d.description || t('A piece just sold. Replace it to complete your box.', 'Une pièce vient d’être vendue. Remplace-la pour compléter ta box.'));
        err.code = 'SOLD_OUT';
        throw err;
      }
    }
    return { cartUrl: root + 'cart' };
  }
  function patch() {
    var api = window.CaroleBoxCheckout;
    if (!api) return false;
    api.create = create;
    api.prefetch = function () {};
    api.warm = function () {};
    api.native = true;
    return true;
  }
  if (!patch()) {
    var tries = 0, timer = setInterval(function () { if (patch() || ++tries > 100) clearInterval(timer); }, 100);
    // Si le script du service n'est pas chargé, on fournit l'objet nous-mêmes.
    setTimeout(function () { if (!window.CaroleBoxCheckout) { window.CaroleBoxCheckout = { create: create, prefetch: function () {}, native: true }; } }, 3000);
  }
})();
